import React from "react"
import notify from "@irati/utils/notify"
import {FormattedMessage} from "@irati/utils/lang"
import getErrorCode from "./getErrorCode"

// using <FormattedMessage> because formatMessage does not allow for defaultMessage
const handleNotifyError = (error, formatMessage) => {
  const defaultError = formatMessage({id: "insights.errors.default"})
  const component = () => <FormattedMessage id={`errors.${getErrorCode(error)}`} defaultMessage={defaultError} />
  notify.error({component, position: "top-right"}, formatMessage)
}

export default handleNotifyError
